import React, { useEffect, useState } from 'react'
import Bread from '../components/Breadcrumb'
import {  } from '../../models/constants'
import { Form, Input, Button } from 'antd'
import { effect, useStore, reducer } from '../../dva16'
import { NUser, EPostRegister, EGetCode, EPutUserPassword, RegistBread, RSetState } from '../../models/constants'
import { useParams } from 'react-router';

import './index.less'

function Register() {
  const { type } = useParams();
  const [mobile, setMobile] = useState('')
  const [time, setTime] = useState(30)
  const { isGetCode } = useStore(NUser)
  const [form] = Form.useForm()
  useEffect(() => {
    if (isGetCode) {
      let id = setInterval(() => {
        setTime((time) => {
          if (time === 0) {
            clearInterval(id)
            reducer(NUser, RSetState, { isGetCode: false })
            setTime(30)
            return
          }
          return time - 1
        })
      }, 1000)
    }
  }, [isGetCode])
  function fetchCode() {
    let Reg = /^(13|15|18|14)\d{9}$/
    if (!Reg.test(Number(mobile))) {
      return
    }
    effect(NUser, EGetCode, { phone: mobile, type: type==='0' ? '注册' : '忘记密码' })
  }
  function onFinish(values) {
    if(type==='0'){
      effect(NUser, EPostRegister, values)
    }else{
      values.newPassword = values.password
      delete values.password
      effect(NUser, EPutUserPassword, values)
    }
    console.log('========>', values)
  }
  return (
    <div id="register">
      <div className="from">
        {Bread(type==='0' ? RegistBread : [{ title: '忘记密码', url: '/regist/1' }])}
        <div className="fromlist">
          <img src={require('../static/logo.jpg')} alt="" />
          <p>{type==='0' ? '注册' : '忘记密码'}</p>
          <div className="center">
            <div className="getCode">
              <Button onClick={() => fetchCode()} style={isGetCode ? { background: '#ccc', color: '#fff', pointerEvents: 'none' } : null}>
                {isGetCode ? `${time}s` : '发送验证码'}
              </Button>
            </div>
            <Form form={form} name="register-form" onFinish={onFinish}>
              <Form.Item
                name="phone"
                rules={[
                  {
                    validator: (rule, value, callback) => {
                      let Reg = /^(13|15|18|14)\d{9}$/
                      if (!Reg.test(Number(value))) {
                        callback('请输入正确的手机号')
                      }
                      // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
                      callback()
                    },
                  },
                ]}
                onChange={(e) => {
                  console.log('3333', e.target.value)
                  setMobile(e.target.value)
                }}
              >
                <Input size="large" prefix={<img src={require('../static/phone.svg')} alt="" />} placeholder="手机号" />
              </Form.Item>

              <Form.Item
                name="captcha"
                rules={[
                  {
                    required: true,
                    message: '* 请输入正确的验证码',
                  },
                ]}
              >
                <Input size="large" prefix={<img src={require('../static/code.svg')} alt="" />} placeholder="验证码" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: '请输入密码',
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  visibilityToggle={false}
                  prefix={<img src={require('../static/password.svg')} alt="" />}
                  placeholder="密码"
                />
              </Form.Item>

              {type==='0' ? <Form.Item
                name="nickname"
                rules={[
                  {
                    required: true,
                    message: '请输入昵称',
                    whitespace: true,
                  },
                ]}
              >
                <Input size="large" prefix={<img src={require('../static/name.svg')} alt="" />} placeholder="昵称" />
              </Form.Item> : null}

              <Form.Item>
                <Button type="primary" htmlType="submit" className="button">
                  确认
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Register
